<template>
  <v-list-item
    :href="`mailto:?subject=${item.text || ''}&body=${item.url || item.tlfno || item.qr || ''}`"
    @click="$emit('input')"
  >
    <v-list-item-icon>
      <v-icon>mdi-email-outline</v-icon>
    </v-list-item-icon>

    <v-list-item-content v-text="$t('components.share.mail')" />
  </v-list-item>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
